<button type="button" class="back-button" (click)="navigate()" [attr.aria-label]="label()">
  <svg class="back-button__icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="2" aria-hidden="true">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 8 8 12 12 16"></polyline>
    <line x1="16" y1="12" x2="8" y2="12"></line>
  </svg>
  <span class="back-button__label">{{ label() }}</span>
</button>
